import { CircularProgress } from '@mui/material'
import { useAtomValue } from 'jotai'
import { FC, useEffect } from 'react'
import { Outlet, useNavigate, useParams } from 'react-router-dom'
import { useLocationChanges } from '../../api/apiQueries'
import { currentLocationChangeAtom } from '../../atoms'
import { Page } from '../Page'

// TODO: Streamline the logic in this component, it works but it's a bit convoluted.
/**
 * Component that handles redirection for the Address Scheduler when the atom state is not set correctly.
 */
export const AddressSchedulerRedirect: FC = () => {
  const navigate = useNavigate()
  const { sid: locationId, locationChangeId } = useParams()
  const currentLocationChange = useAtomValue(currentLocationChangeAtom)
  const locationChanges = useLocationChanges(locationId)

  const hasPendingAddressChange = locationChanges.data?.some(change => change.state === 'pending')

  const atomLocationIdInconsistentWithUrl =
    !!currentLocationChange && currentLocationChange.locationId !== undefined && currentLocationChange.locationId !== locationId
  const atomLocationChangeIdInconsistentWithUrl = !!currentLocationChange && locationChangeId !== currentLocationChange.id

  const atomInconsistentWithUrl = atomLocationIdInconsistentWithUrl || atomLocationChangeIdInconsistentWithUrl

  const atomMissingOrInconsistentWithUrl = !currentLocationChange || atomInconsistentWithUrl

  const attemptToCreateLocationChangeWhilePendingExists = !locationChangeId && hasPendingAddressChange

  const shouldRedirect = atomMissingOrInconsistentWithUrl || attemptToCreateLocationChangeWhilePendingExists

  useEffect(() => {
    if (shouldRedirect) {
      navigate('../overview', { replace: true })
    }
  }, [navigate, shouldRedirect])

  if (locationChanges.isLoading || shouldRedirect) {
    // Render a placeholder page before navigating away.
    return (
      <Page title={'Address Change Scheduler'} showLocationSearchBar={false}>
        <CircularProgress />
      </Page>
    )
  } else {
    // Otherwise, render the children components.
    return <Outlet />
  }
}
